(function () {
	'use strict';

    angular.module("imApp").factory("orderCustomerServiceService", ['$ihttp', function ($ihttp) {
		let service = {
            getInfo: function (parms) {
                return $ihttp.post({
                    method: 1872,
                    parameters: parms || {}
                });
            },
            listCommunications: function (parms) {
                return $ihttp.post({
                    method: 1871,
                    parameters: parms || {}
                });
            },
            listOrderLines: function (parms) {
                return $ihttp.post({
                    method: 1864,
                    parameters: parms || {}
                });
            },
            listConsignments: function (parms) {
                return $ihttp.post({
                    method: 1865,
                    parameters: parms || {}
                });
            },
            listRequisitions: function (parms) {
                return $ihttp.post({
                    method: 1866,
                    parameters: parms || {}
                });
            },
            listPurchaseLines: function (parms) {
                return $ihttp.post({
                    method: 1869,
                    parameters: parms || {}
                });
            },
            calculateDeliveryDate: function (orderInfo) {
                return $ihttp.post({
                    method: 1899,
                    parameters: orderInfo
                });
            },
            updateColumnResize: function (parms) {
                return $ihttp.post({
                    method: 1457,
                    parameters: parms
                });
            }
        };

        return service;
    }]);
})();
